module.exports = __webpack_public_path__ + "img/home-empresas-1.56369c6.png";